(() => {
  const desktop = window.matchMedia('(min-width: 750px)');
  const margin = 64;
  const instances = new Map();

  function measure(details) {
    if (!desktop.matches || !details.isConnected) {
      details.style.removeProperty('--jf-details-sticky-top');
      return;
    }
    const button = details.querySelector('product-form-component [ref="addToCartButton"]') || details.querySelector('.jf-event-sold-out-signup__form');
    if (!button) {
      details.style.removeProperty('--jf-details-sticky-top');
      return;
    }
    const detailsRect = details.getBoundingClientRect();
    const buttonRect = button.getBoundingClientRect();
    const content = details.querySelector('.group-block');
    const detailsHeight = Math.max(details.scrollHeight, content?.scrollHeight || 0);
    const header = document.querySelector('#header-group');
    const headerHeight = header ? Math.max(0, Math.min(window.innerHeight, header.getBoundingClientRect().bottom)) : 0;
    const availableHeight = window.innerHeight - headerHeight;
    let top;

    if (detailsHeight <= availableHeight) {
      top = headerHeight + (availableHeight - detailsHeight) / 2;
    } else {
      const buttonOffset = buttonRect.bottom - detailsRect.top;
      if (buttonOffset <= 0) return;
      top = window.innerHeight - margin - buttonOffset;
    }

    details.style.setProperty('--jf-details-sticky-top', top + 'px');
  }

  function init() {
    document.querySelectorAll('.jf-event-product-info .product-details.sticky-content--desktop').forEach(details => {
      if (instances.has(details)) return;
      const observer = new ResizeObserver(() => measure(details));
      observer.observe(details);
      const content = details.querySelector('.group-block');
      if (content) observer.observe(content);
      const button = details.querySelector('product-form-component [ref="addToCartButton"]') || details.querySelector('.jf-event-sold-out-signup__form');
      if (button) observer.observe(button);
      instances.set(details, observer);
      measure(details);
    });
    for (const [details, observer] of instances) {
      if (!details.isConnected) {
        observer.disconnect();
        instances.delete(details);
      }
    }
  }

  window.addEventListener('resize', () => {
    init();
    for (const details of instances.keys()) measure(details);
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
